import api from "./axios";

const BASE = "/settings";

/**
 * List items in a section (paginated, searchable).
 */
export const listSettings = async (section, params = {}) => {
  const response = await api.get(`${BASE}/${section}`, { params });
  return response.data;
};

/**
 * List active items for dropdown population (no pagination).
 */
export const listActiveSettings = async (section) => {
  const response = await api.get(`${BASE}/${section}/active`);
  return response.data;
};

/**
 * Create a new settings item.
 */
export const createSetting = async (section, data) => {
  const response = await api.post(`${BASE}/${section}`, data);
  return response.data;
};

/**
 * Update a settings item.
 */
export const updateSetting = async (section, id, data) => {
  const response = await api.put(`${BASE}/${section}/${id}`, data);
  return response.data;
};

/**
 * Soft-delete a settings item.
 */
export const deleteSetting = async (section, id) => {
  const response = await api.delete(`${BASE}/${section}/${id}`);
  return response.data;
};

/**
 * Export section as CSV (returns blob).
 */
export const exportSettings = async (section) => {
  const response = await api.get(`${BASE}/${section}/export`, {
    responseType: "blob",
  });
  return response;
};
